import Vue from "vue";
import VueRouter from "vue-router";
import Dashboard from "../views/_report/Dashboard.vue";
import Personnel from "../views/Personnel.vue";
import AddPersonnel from "../views/forms/AddPersonnel.vue";
import Contract from "../views/Contract.vue";
import ExContract from "../views/ExContract.vue";
Vue.use(VueRouter);

const routes = [

  {
    path: "/",
    name: "Index",
    component: () => import("../views/index.vue"),
    meta: {
      guest: true,
    },
  },
  {
    path: "/signin",
    name: "SignIn",
    component: () => import("../views/SignIn.vue"),
    meta: {
      guest: true,
    },
  },
  {
    path: "/linktoline",
    name: "LinktoLine",
    component: () => import("../views/LinktoLine.vue"),
  },
  {
    path: "/fdashboard",
    name: "FrontDashboard",
    component: () => import("../views/FrontDashboard.vue"),
    meta: {
      guest: true,
    },
  },
  {
    path: "/DrillDown",
    name: "DrillDown",
    component: () => import("../views/DrillDown.vue"),
    meta: {
      guest: true,
    },
  },
  {
    path: "/register",
    name: "register-newCustomer",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/forms/AddCustomer.vue"),
    meta: {
      guest: true,
    },
  },
  {
    path: "/bill-report:l_mas",
    name: "bill-report-anamai",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/LinkBillReport.vue"),
  },
  {
    path: "/waste-report-plublic-link/:l_mas",
    name: "waste-report-plublic-link",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/WasteReportPlublicLink.vue"
      ),
  },
  {
    path: "/qr-code",
    name: "qr-code",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/forms/PrintQR.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/l-Doc/:tra_id",
    name: "linkReportDocument",
    component: () => import("../views/linkReportDocument.vue"),
  },
  {
    path: "/Customer/:cus_id",
    name: "LinkCustomer",
    component: () => import("../views/CustomerLink.vue"),
  },
  {
    path: "/contract",
    name: "Contract",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/View.vue"),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "all-contract",
        name: "AllContract",
        component: Contract,
      },
      {
        path: "expire-contract",
        name: "ExContract",
        component: ExContract,
      },
    ],
  },
  {
    path: "/qeue",
    name: "Qeue",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/View.vue"),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "car-qeue",
        name: "CarQeue",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/CarQeue.vue"),
      },
      {
        path: "manage-zone",
        name: "ManageZone",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/manageZone.vue"),
      },
    ],
  },
  {
    path: "/seller-order",
    name: "Seller",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/View.vue"),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "quotation",
        name: "quotation",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Quotation.vue"),
      },
      {
        path: "bill",
        name: "bill",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Bill.vue"),
      },
      {
        path: "invoices",
        name: "invoices",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Invoices.vue"),
      },
    ],
  },
  {
    path: "/wastedocument",
    name: "WasteDocument",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/View.vue"),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "waste-document",
        name: "waste-document",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/WasteDocument.vue"),
      },
      {
        path: "add-waste-document",
        name: "add-waste-document",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/forms/AddWasteDocument.vue"
          ),
      },
      {
        path: "edit-waste-document",
        name: "edit-waste-document",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/forms/EditWasteDocument.vue"
          ),
      },

      {
        path: "report-wastdocument",
        name: "report-wastdocument",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/forms/ReportWasteDocument.vue"
          ),
      },
    ],
  },
  {
    path: "/newCustomer",
    name: "newCustomer",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/View.vue"),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "all-newCustomer",
        name: "all-newCustomer",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/_customer/Customer.vue"
          ),
      },
      {
        path: "confirm-newCustomer",
        name: "confirm-newCustomer",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/_customer/ConfirmCustomer.vue"
          ),
      },
      {
        path: "payment-customer",
        name: "payment-customer",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/_customer/PaymentCustomer.vue"
          ),
      },
      {
        path: "quotation-customer",
        name: "quotation-customer",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/_customer/QuotationCustomer.vue"
          ),
      },
      {
        path: "print-qrcode",
        name: "print-qrcode",
        component: () => import("../views/PrintQRcode.vue"),
      },
      {
        path: "cancel-customer",
        name: "cancel-customer",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/_customer/CancelCustomer.vue"
          ),
      },
      {
        path: "add-newCustomer",
        name: "add-newCustomer",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/forms/AddDataCustomer.vue"
          ),
      },
    ],
  },
  {
    path: "/settings",
    name: "Setting",
    component: () => import("../views/View.vue"),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "company-profile",
        name: "company-profile",
        component: () => import("../views/DataAdmin.vue"),
      },
      {
        path: "company-insert-destroy",
        name: "company-insert-destroy",
        component: () => import("../views/InsertDestroy.vue"),
      },
      {
        path: "company-data-destroy",
        name: "company-data-destroy",
        component: () => import("../views/DataDestroy.vue"),
      },
    ],
  },
  {
    path: "/manage",
    name: "Manage",
    component: () => import("../views/View.vue"),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "all-personnel",
        name: "all-personnel",
        component: () => import("../views/Personnel.vue"),
      },
      {
        path: "add-personnel",
        name: "add-personnel",
        component: () => import("../views/forms/AddPersonnel.vue"),
      },
      {
        path: "all-car",
        name: "all-car",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Car.vue"),
      },
      {
        path: "add-car",
        name: "add-car",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/forms/AddCar.vue"),
      },
      {
        path: "all-supply",
        name: "all-supply",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Supply.vue"),
      },
    ],
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: () => import("../views/View.vue"),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "all-report",
        name: "all-report",
        component: () => import("../views/_report/Dashboard.vue"),
      },
      {
        path: "bill-report",
        name: "bill-report",
        component: () => import("../views/_report/BillReport.vue"),
      },
      {
        path: "invoice-report",
        name: "invoice-report",
        component: () => import("../views/_report/InvoiceReport.vue"),
      },
      {
        path: "waste-report",
        name: "waste-report",
        component: () => import("../views/_report/WasteReport.vue"),
      },
    ],
  },
  {
    path: "/SummaryMonth",
    name: "SummaryMonth",
    component: () => import("../views/_summaryCollectRemoval/SummaryMonth.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/Transfer-Waste",
    name: "Transfer-Waste",
    component: () =>
      import("../views/_summaryCollectRemoval/Transfer_WasteAll.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/form",
    name: "AllForm",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AllForm.vue"),
  },
  {
    path: "/bill",
    name: "BillForm",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/forms/BillForm.vue"),
  },
  
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // console.log(to.fullPath)
    if (localStorage.getItem("jwt") == null) {
      next({
        path: "/",
        params: { nextUrl: to.fullPath },
      });
    } else {
      next();
    }
  } else if (to.matched.some((record) => record.meta.guest)) {
    if (localStorage.getItem("jwt") == null) {
      next();
    } else {
      next({ name: "all-newCustomer" });
    }
  } else {
    next();
  }
});

export default router;
